import Vue from 'vue'
import './plugins/vuetify'
import './plugins/base'
import store from './store.js'
import EffectInput from 'effect-input'
import 'effect-input/dist/index.css'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import App from './App.vue'
import router from './router'
import 'video.js/dist/video-js.css'
import '../node_modules/vue-video-player/src/custom-theme.css'
import VueVideoPlayer from 'vue-video-player'
import firebase from 'firebase'
import DateFilter from './filters/date'
import './registerServiceWorker'
import BaiduMap from 'vue-baidu-map'

/* eslint-disable */

Vue.use(BaiduMap, {
ak: 'sgrcI0wMfPveIO0EL15tfiWgzytc5gsY'
})
Vue.filter('date', DateFilter)
Vue.filter('toUpCase',(value)=>{          //标题的首字母大写
  let strArr = value.toUpperCase().split(' ');
  for (let i=0,len=strArr.length; i<len; i++){
    strArr[i] = strArr[i].charAt(0)+strArr[i].slice(1).toLowerCase();
  }
  return strArr.join(' ');
});
Vue.use(EffectInput)
Vue.use(ElementUi)
Vue.use(VueResource)
Vue.config.productionTip = false
Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)


let app;
firebase.auth().onAuthStateChanged(user => {
if(!app){
app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created () {
    this.$store.dispatch('loadMeetups')
    this.$store.dispatch('autoSignIn', user)
  }
})
}
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)){
  if(!firebase.auth().currentUser){
  next({path: '/Login',
  query: {redirect: to.fullPath}
  });
  } else {
  next();
  }
  }else if(to.matched.some(record => record.meta.requiresGuest)){
  if(firebase.auth().currentUser) {
      next({path: '/',
    query: {redirect: to.fullPath}
    });
    } else {
    next();
    }
  } else {
    next();
  } 
  });


